var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var UIProgressTimer = require("clover/panel/component/common/UIProgressTimer")
var UISubscribeMsg = require("clover/ui/UISubscribeMessage")
let ShareUtil = require("clover/utils/ShareUtil")
let { DCShareShowError } = require("clover/dc/DCConst");
var FriendPvpActivityMainPanel = xClass("FriendPvpActivityMainPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_pvp_panel_friendlymatch.csb")
})

// FriendPvpActivityMainPanel.show = function (logic, onCloseCb) {
//     var panel = FriendPvpActivityMainPanel.create(logic, onCloseCb);

//     return panel;
// }

FriendPvpActivityMainPanel.prototype.ctor = function (logic, resetLogicBusycb, onCloseCb,res) {
    var self = this;
    self.resourceRelease = false;
    BasePanel.prototype.ctor.call(self);
    self.logic = logic;
    self.resetLogicBusycb = resetLogicBusycb;
    self.onCloseCb = onCloseCb;
    self.roomInited = false; // 创建房间后true
    self.res = res

    self.activityInfo = self.logic.pvpManager.getActivityInfo();

    // 先读配置中的积分最大值和网络背景图
    var sp = new cc.Sprite();
    var old = self.getChildByName("img_mode");
    self.addChild(sp, 1);
    CfgManager.load("friend_pvp")
    .then((data) => {
        var config = data.get("friend_pvp");
        self.pvpRandomDuration = config.pvp_random_duration;
        var mode = self.activityInfo.pvpMode || 1;
        self.mode = mode;
        var url = config["mod_0"+mode+"_pic"];

        function loadThirdPartyResCallback(err) {
            let data = err? null: cc.loader.getRes(url);
            if (data) {
                var pos = old.getPosition();
                sp.initWithTexture(data);
                if (self.mode == 1){
                    sp.setPosition(cc.pAdd(pos, cc.p(sp.width/2-16, 0-sp.height/2+5)));
                }else{
                    sp.setPosition(cc.pAdd(pos, cc.p(sp.width/2-8, 0-sp.height/2)));
                }
                if (_G.__use_low_effect){
                    sp.setScale(0.62);
                    sp.x -= 160;
                    sp.y += 82;
                }
                old.removeFromParent(true);
            }
        }
        
        cc.loader.load(url, loadThirdPartyResCallback);

        self.scoreMax = config.pvp_progress_scoremax;

        self.initUI();
        
        self.popup(true, false, handler(self, self.getRankList));

        CfgManager.release("friend_pvp");
    });
}
FriendPvpActivityMainPanel.prototype.getRankList = function(){
    var self = this
    self.resetLogicBusycb();
    if (self.logic.pvpManager.getNeedRequestRankList()){
        var onSuccess = function(evt){
            self.logic.pvpManager.setRankList(evt.data);
            if (self.resourceRelease == false)
            {
                self.initRankView(evt.data);
            }
        }
        var onFail = function(evt){
            cc.error(evt);
        }
        var http = PvpRankListHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load();
    }else{
        self.initRankView(self.logic.pvpManager.getRankList());
    }
}

FriendPvpActivityMainPanel.prototype.onEnter = function () {
    var self = this
    BasePanel.prototype.onEnter.call(self)
}

FriendPvpActivityMainPanel.prototype.initUI = function(){
    var self = this;    


    var scoreTxt = self.getChildByName("num");
    scoreTxt.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    scoreTxt.setString(self.activityInfo.totalScore); //总积分
    scoreTxt.setAnchorPoint(cc.p(0.5, 0));
    scoreTxt.x += 60;
    scoreTxt.y -= 60;
    scoreTxt.setLocalZOrder(2);
    if (self.mode == 1){
        scoreTxt.x += 0;
        scoreTxt.y -= 5;
    }else if (self.mode == 2){
        scoreTxt.x += 0;
        scoreTxt.y -= 5;
    }else if (self.mode == 3){
        scoreTxt.x -= 2;
        scoreTxt.y -= 10;
    }else if (self.mode == 4){
        scoreTxt.x -= 2;
        scoreTxt.y -= 4;
    }else if (self.mode == 5){
        scoreTxt.x -= 2;
        scoreTxt.y -= 2;
    }else if (self.mode == 6){
        scoreTxt.x -= 4;
        scoreTxt.y -= 7;
    }else if (self.mode == 7){
        scoreTxt.x -= 3;
        scoreTxt.y -= 12;
    }else if (self.mode == 8){
        scoreTxt.x -= 5;
        scoreTxt.y -= 37;
    }

    self.getChildByName("title").x += 35;
    self.getChildByName("prompt").getChildByName("num").y -= 8;
    self.getChildByName("prompt").getChildByName("num").x -= 3;
    
    quickBuildUIBUtton(self.getChildByName("btn_close"), () => {
        if (self.isBusy){
            return;
        }
        self.isBusy = true;
        self.onCloseCb()
    })

    quickBuildUIBUtton(self.getChildByName("letter2"), () => {
        if (self.isBusy){
            return;
        }
        self.isBusy = true;
        if (self.rankScrollView){
            self.rankScrollView.removeFromParent();
            self.rankScrollView = null;
        }
        var selfRank = self.getChildByName("selfRank");
        if (selfRank){
            selfRank.removeFromParent();
        }
        DCAssist.userTrack("PVP", "click_result_icon", {"abtest":"new"});
        self.logic.showStandingPanel(handler(self, self.standingPanelCloseCb));
    })
    self.getChildByName("letter2").getChildByName("dot").setVisible(false);

    if (self.activityInfo.reportRedPoint > 0){
        self.setLetterNew(true);    
    }else{
        self.setLetterNew(false);    
    }
    self.getChildByName("letter2").setLocalZOrder(2);

    // 模式
    var label = self.getChildByName("label").getChildByName("txt");
    label.y -= 8;
    label.setFontStyle("bold");
    label.setString(getText("pvp.modetip." + self.mode));
    self.getChildByName("label").setLocalZOrder(2);

    // 活动时间
    self.getChildByName("txt_time1").y -= 7;
    self.getChildByName("txt_time1").width += 30;
    self.getChildByName("txt_time1").setString("活动时间：即日起 - " + formatTime2Str2(self.activityInfo.endTime));

    var ticketNode = self.getChildByName("ticket2");
    ticketNode.getChildByName("txt").setString(getText("pvp.ticket.text"));
    ticketNode.getChildByName("txt").x -= 75;
    ticketNode.getChildByName("txt").y -= 4;
    ticketNode.getChildByName("txt").width += 100;
    ticketNode.getChildByName("txt").getVirtualRenderer().setHorizontalAlignment(cc.TEXT_ALIGNMENT_RIGHT);

    // 积分进度条
    self.getChildByName("pb").setLocalZOrder(2);

    self.progressTimer = UIProgressTimer.create(self.getChildByName("pb").getChildByName("progressbar"));
    var w = self.progressTimer.width;
    self.progressTimer.setProgressBarChildPositionOffset(cc.p(-5, 33));
    self.progressTimer.setContentOffset(5, -34);
    self.progressTimer.progressBar.height += 5;
    self.progressTimer.progressBar.width -= 6;
    self.progressTimer.pWidth -= 6;
    self.progressTimer.progressBarChild.width -= 6;

    // 积分进度条上的奖励图标，有能领的话气泡就显示在能领的上面
    var scoreRewards = self.activityInfo.scoreRewards;
    self.canGetIcon = null;
    self.scoreIcons = new Array();
    for(var i = 1; i < scoreRewards.length; i++){
        var score = scoreRewards[i].score;
        
        var reward = scoreRewards[i].rewards[1];
        var itemId = reward.itemId;
        var num = reward.num;
        var rewardIcon = cc.Sprite.createWithSpriteFrameName("properties/prop_"+ itemId +".png");
        rewardIcon.setScale(0.5);
        rewardIcon.setPosition((w*score/self.scoreMax)*1.1-5, -30);
        self.getChildByName("pb").addChild(rewardIcon);
        rewardIcon.name = score;
        self.scoreIcons.push(rewardIcon);

        let numLabel = cc.LabelBMFont.create("x"+num, "font/berlinsansfb_30_bluestroke.fnt");
        numLabel.setPosition((w*score/self.scoreMax)*1.1, -45);
        numLabel.setNextFontPositionXOffset(-4);
        numLabel.setScale(0.80);
        self.getChildByName("pb").addChild(numLabel);

        if (itemId == 10019 || itemId == 10020){
            // 精力瓶要露出标签
            numLabel.x += 25;
        }


        quickBuildUIBUtton(rewardIcon, (evt) => {
            self.getRankRewards(evt);
        })
    }

    self.scoreBubble = self.getChildByName("pb").getChildByName("bubblebox");
    self.scoreBubble.getChildByName("txt").y -= 10;
    self.scoreBubble.getChildByName("txt").setFontSize(23);
    self.scoreBubble.setVisible(false);


    self.refreshScoreProgress();

    var selfBg = self.getChildByName("player").getChildByName("entry_blue");
    var size = selfBg.getContentSize();
    selfBg.setContentSize(cc.size(size.width + 6, size.height));
    selfBg.x -= 6;

    var quesBtn = self.getChildByName("prompt");
    quickBuildUIBUtton(quesBtn, () => {
        if (self.scoreBubble.isVisible()){
            self.scoreBubble.setVisible(false);
        }
        let [QuesPanel, PanelEvent] = require("clover/panel/CommonQuesPanel");
        QuesPanel.show(
            getText("pvp.icon"),
            getText("pvp.description"), 
            getText("pvp.battle.reportbutton02"), 
            true,
            (panel) => {
                panel.on(PanelEvent.Close, () => {
                    panel.onClose();
                });
                panel.popup(true, false);
            });
    })
    
    // 匹配和好友邀请按钮
    var randomBtn = self.getChildByName("btn_random");
    randomBtn.getChildByName("label").x += 10;
    randomBtn.getChildByName("label").setString(getText("pvp.random.button"));
    quickBuildUIBUtton(randomBtn, () => {
        if (self.isBusy){
            return;
        }
        if (self.scoreBubble.isVisible()){
            self.scoreBubble.setVisible(false);
        }
        if (!self.checkMatchTime()){
            Toast.make(getText("pvp.random.tip"));
            return;
        }
        if (!self.checkTicket()){
            return;
        }
        self.isBusy = true;
        var resetBusy = function(){
            self.isBusy = false;
        }

        var onSuccess = function(evt){var data = evt.data;
            if (data.status == -1){
                resetBusy();
                Toast.make(getText("error.tip.761316"));
                return;
            }
            DCAssist.userTrack("PVP", "click_random_btn", {"abtest":"new"});
            self.logic.pvpManager.isInviteMode = false;
            self.logic.showMatchPanel(null, self.activityInfo);
            self.runAction(cc.sequence(cc.delayTime(1), cc.callFunc(resetBusy)));
        }
        var onFail = function(evt){
            cc.error(evt);
            Toast.make(getText("error.tip." + tostring(evt.data)));
            resetBusy();
        }
        var http = FriendPvpMatchHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(-1);
    })
    var inviteBtn = self.getChildByName("btn_invite");
    inviteBtn.getChildByName("label").x += 10;
    inviteBtn.getChildByName("label").setString(getText("pvp.invite.button"));
    quickBuildUIBUtton(inviteBtn, () => {
        if (self.isBusy){
            return;
        }
        DCAssist.userTrack("PVP", "click_invite_friend_btn", {"abtest":"new"});
        if (self.scoreBubble.isVisible()){
            self.scoreBubble.setVisible(false);
        }
        if (!self.checkTicket()){
            return;
        }
        if (self.activityInfo.inviteCnt <= 0){
            Toast.make(getText("error.tip.761307"));
            return;
        }
        self.isBusy = true;
        self.requestCreateRoom();
        self.logic.pvpManager.isInviteMode = true;
    })

    // 匹配的时间
    var time2 = self.getChildByName("txt_time2");
    time2.x += 10;
    time2.y -= 10;
    time2.setString(getText("pvp.random.text"));
    
    self.refreshTicket();

    var listener = cc.EventListenerTouchOneByOne.create();
	listener.setSwallowTouches(true);
	listener.registerScriptHandler(handler(self, self.onTouchStart), cc.Handler.EVENT_TOUCH_BEGAN);
    cc.eventManager.addListener(listener, self);
    
    self.initSubscribeMessage()

    // 展示对战按钮打点    
    DCAssist.dc4ShareShow("pvp_new", self.calShareShowError())
}
FriendPvpActivityMainPanel.prototype.calShareShowError = function() {
    let self = this;
    
    if (!self.activityInfo)
        return DCShareShowError.None;

    if(self.activityInfo.freeCount + self.activityInfo.adTicketCount <= 0)
        return DCShareShowError.NoTicket
        
    if (self.activityInfo.inviteCnt <= 0){
        return DCShareShowError.Limit;
    }
    
    return DCShareShowError.None;
}

FriendPvpActivityMainPanel.prototype.checkTicket = function(){
    var self = this;
    if ((self.activityInfo.freeCount + self.activityInfo.adTicketCount) <= 0){
        DCAssist.userTrack("PVP", "no_tickets_page_show", {"abtest":"new"});
        function resOnSuccess() {
            var getTicketPanel = require("activity/PvpActivity/FriendPvpActivityGetTicketPanel");
            getTicketPanel.show(self.activityInfo, handler(self, self.adRefreshTicket));
        }
        function resOnFail() {
            Toast.make(getText("error.tip.timeout"))
        }
        preloadWithLoading(["packed/PvpGetTicketRes.pack"], resOnSuccess, resOnFail, resOnFail);
        return false;
    }else{
        return true;
    }
}

FriendPvpActivityMainPanel.prototype.checkMatchTime = function(){
    // 前端不检查时间
    return true;
    // var self = this;
    // var d = self.pvpRandomDuration.split(",");
    // var s = d[0].split(":");
    // var e = d[1].split(":");

    // var start = parseInt(s[0]) * 3600 + parseInt(s[1]) * 60 + parseInt(s[2]);
    // var end = parseInt(e[0]) * 3600 + parseInt(e[1]) * 60 + parseInt(e[2]);
    // var cur = Localhost.timeInSec();
    // cur = new Date(cur*1000);
    // var h = cur.getHours();
    // var m = cur.getMinutes();
    // var s = cur.getSeconds();
    // cur = h * 3600 + m * 60 + s;
    // cc.log("start", start, "end", end, "cur", cur);
    // if (start <= cur && cur < end){
    //     return true;
    // }else{
    //     return false;
    // }
}

FriendPvpActivityMainPanel.prototype.refreshTicket = function(){
    var self = this;
    var ticketNode = self.getChildByName("ticket2");
    var times = self.activityInfo.freeCount + self.activityInfo.adTicketCount;
    ticketNode.getChildByName("num").setString("x"+times); //票子
}

FriendPvpActivityMainPanel.prototype.adRefreshTicket = function(data){
    var self = this;
    if (data.adCount){
        self.activityInfo.adCount = data.adCount;
    }
    if (data.adTicketCount){
        self.activityInfo.adTicketCount = data.adTicketCount;
    }
    if (data.adTicketCount2){
        self.activityInfo.adTicketCount += data.adTicketCount2;
    }
    self.refreshTicket();
}

FriendPvpActivityMainPanel.prototype.onTouchStart = function(){
    var self = this;
    if (self.scoreBubble.isVisible()){
        self.scoreBubble.setVisible(false);
    }
}



FriendPvpActivityMainPanel.prototype.refreshScoreProgress = function(){
    var self = this;
    var w = self.progressTimer.width;
    
    self.progressTimer.setProgress(self.activityInfo.totalScore/self.scoreMax);

    var hasGetRewards = self.activityInfo.scoreRewardsIsGain || table();
    var scoreRewards = self.activityInfo.scoreRewards;
    var canGetScore = 0;
    var canGetScoreIdx = 0;
    self.canGetIcon = null;
    for(var i = 1; i < scoreRewards.length; i++){
        var score = scoreRewards[i].score;
        if (self.activityInfo.totalScore >= score){
            var hasGet = false;
            for (var j = 1; j < hasGetRewards.length; j++){
                if (hasGetRewards[j] == score){
                    var hasGet = true;
                }
            }
            if (hasGet == false && (canGetScore == 0 || canGetScore >= score)){
                canGetScore = score;
                canGetScoreIdx = i;
            }
        }
    }
    cc.log("canGetScore", canGetScore)
    cc.log("canGetScoreIdx", canGetScoreIdx)
    self.canGetScore = canGetScore;

    if (canGetScoreIdx > 0){
        self.canGetIcon = self.scoreIcons[canGetScoreIdx-1];
        self.rewardCanGetAnim();
        self.scoreBubble.setVisible(true);
        
        self.scoreBubble.x = w*canGetScore/self.scoreMax-45;
        self.scoreBubble.y = 80;
        self.scoreBubble.getChildByName("txt").setString(getText("pvp.progress.receive.tip"));     
        
        if (canGetScore > self.scoreMax/2){
            self.scoreBubble.getChildByName("bubblebox").scaleX = -1;
            self.scoreBubble.getChildByName("bubblebox").x = 160;
            self.scoreBubble.x -= 20
        }else{
            self.scoreBubble.getChildByName("bubblebox").scaleX = 1;
            self.scoreBubble.getChildByName("bubblebox").x = -10;
        }
    }
}

FriendPvpActivityMainPanel.prototype.initRankView = function(data){
    var self = this;
    if (self.rankScrollView){
        self.rankScrollView.removeFromParent(true);
        self.rankScrollView = null;
    }
    self.ranks = new Array();
    var selfData = null;
    for(var i = 0; i < data.list.length; i++){
        if (data.list[i] != null){
            data.list[i].userShow = data.userShows[i] //在列表里增加角色装扮
            self.ranks.push(data.list[i]);
            if (data.list[i].uid == UserManager.getInstance().uid){
                selfData = data.list[i];
            }
        }
    }
    if (selfData == null){
        selfData = {
            rank: self.activityInfo.pvpRank?  self.activityInfo.pvpRank: "1000+",
            nickname:UserManager.getInstance().profile.name,
            avatar:UserManager.getInstance().profile.headUrl,
            totalScore:self.activityInfo.totalScore,
        }
        if (self.activityInfo.winRate != null){
            selfData.winRate = self.activityInfo.winRate;
        }else{
            selfData.winRate = "???"
        }
    }

    var listLength = self.ranks.length;
    var listLength2 = listLength < 3 ? 3 : listLength;
    var innerHeight = 53 * listLength2;
    var size = cc.size(505, 155);
    var pos = cc.p(286, -527);
    var anchor = cc.p(0.5, 0.5);
    var listView = require("activity/PvpActivity/ListView");
    var rankScrollView = listView.create(listLength2, size, cc.size(505, innerHeight));
    rankScrollView.setDirection(ccui.ScrollViewDir.vertical);
    rankScrollView.setPosition(pos);
    rankScrollView.setAnchorPoint(anchor);
    rankScrollView.setRefreshItemContentFunc(handler(self, self.refreshRankItemContent));
    self.addChild(rankScrollView);
    self.rankScrollView = rankScrollView;

    for(var i = 0; i < 6; i++){
        var item = cc.CSLoader.createNode("cocos/panel_pvp_player.csb");
        var avatarIcon = item.getChildByName("frame_photo");
        avatarIcon.y += 3;
        var photo = avatarIcon.getChildByName("photo");
        photo.x += 50
        photo.y -= 50
        photo.setAnchorPoint(cc.p(0.5, 0.5));
        item.getChildByName("name").y = -15;
        if (i == 5){
            // 固定位置显示自己的
            if (self.selfScoreItem){
                self.selfScoreItem.removeFromParent(true);
                self.selfScoreItem = null;
            }
            self.addChild(item);
            item.setName("selfRank");
            item.setPosition(35, -610);
            if (self.activityInfo.pvpCount == 0){
                selfData.rank = "???";
                selfData.winRate = "???";
            }
            if (!selfData.userShow) selfData.userShow = DressManager.getInstance().getInUse()
            self.refreshRankItemContent(item, selfData);
            item.getChildByName("line").removeFromParent(true);
            self.selfScoreItem = item;
            HeadImageLoader.loadImage(photo, UserManager.getInstance().profile.headUrl);
            quickBuildUIBUtton(item.getChildByName("name"), (evt) => {
                
            })
            quickBuildUIBUtton(item.getChildByName("frame_photo"), (evt) => {
                
            })
        }else{
            rankScrollView.addItem(item, i);
            item.y -= 5;
            rankScrollView.refreshItemContent(item);
            var touchLayer = cc.Layer.create();
            touchLayer.setContentSize(100, 40);
            item.addChild(touchLayer);
            touchLayer.setPosition(60, -43);
            quickBuildUIBUtton(touchLayer, (evt) => {
                self.showUserCard(evt.target.getParent());
            })
        }

        var rank = item.getChildByName("num2");
        rank.x -= 2;
        rank.y = -15;
        rank.width += 6
        let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
        if (global.mini && pf != MiniPlatform.tt) {
            rank.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        }
        
        var score = item.getChildByName("num1");
        score.y = -15;
        if (global.mini && pf != MiniPlatform.tt) {
            score.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        }
        item.getChildByName("txt3").y = -15;
        item.getChildByName("icon_trophy_node").y = -13;
    }

    if (listLength == 0){
        // 榜上是空的时候
        if (self.noRanklistLabel){

        }else{
            var label = cc.LabelTTF.create(getText("pvp.rank.none"), null, 22);
            self.addChild(label);
            label.setColor(cc.c4b(255, 255, 255, 255));
            label.setPosition(290, -540);
            self.noRanklistLabel = label;
        }
    }else{
        if (self.noRanklistLabel){
            self.noRanklistLabel.removeFromParent(true);
            self.noRanklistLabel = null;
        }
    }
}

FriendPvpActivityMainPanel.prototype.showUserCard = function(item){
    var self = this;
    if (self.isBusy){
        return;
    }
    var idx = item.idx;
    var data = self.ranks[idx];
    if (data){
        self.isBusy = true;
        var resetBusy = function(){
            self.isBusy = false;
        }
        var uid = data.uid;
        UserManager.getInstance().openNameCradPanel(uid, {type: "pvp"}, resetBusy);           
    }
}

FriendPvpActivityMainPanel.prototype.refreshRankItemContent = function(item, data){
    var self = this;
    var idx = item.idx;
    if (!data){
        data = self.ranks[idx];
    }
    let removeAndNew = (node)=>{
        let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
        if (global.mini && pf != MiniPlatform.tt)  return node
        if (!node) return cc.LabelTTF.create("", null, 22)
        let parent = node.getParent()
        node.removeFromParent()
        let newLabel = cc.LabelTTF.create("", null, node.getFontSize())
        parent.addChild(newLabel)
        newLabel.setName(node.getName())
        newLabel.setPosition(node.getPosition())
        newLabel.setAnchorPoint(node.getAnchorPoint())
        return newLabel
    }
    if (data){
        item.setVisible(true);
        if (item.getChildByTag(999)){
            item.getChildByTag(999).removeFromParent(true);
        }
        item.setLocalZOrder(1000-idx);
        var rankLable = item.getChildByName("num2");
        rankLable = removeAndNew(rankLable)
        // cc.log(data.rank)
        // cc.log(data.winRate)
        var rank = data.rank;
        if (rank){
            if (rank == "???"){
                rankLable.setString(data.rank);
            }else if (rank > 0 && rank <= 3){
                // 前三名有奖牌
                rankLable.setString("");
                var rankIconNode = cc.Node.create();
                var rankIcon = cc.Sprite.createWithSpriteFrameName("panel_pvp/star_icon"+rank+".png");
                rankIconNode.addChild(rankIcon)
                item.addChild(rankIconNode, 1, 999);
                rankIconNode.setPosition(36, -28);
                rankIconNode.setScale(0.95);
            }else{
                // 
                rankLable.setString(data.rank);
            }
        }
        var nameLable = item.getChildByName("name")
        nameLable.originFontColor = cc.c4b(255, 255, 255, 255)
        // cc.log("battlepass pvpRankList ", nameLable, nameLable.getTextColor(), item, data)
        // UIUtils.fixTextWidth(nameLable, HeDisplayUtil.urlDecode(data.nickname), 140);

        if (data.userShow){ //如果有usershow信息
            // let labelid = UIUtils.getIdFromUsershow(data.userShow, "label")
            // nameLable.originFontColor = nameLable.getTextColor();
            UIUtils.createNameWithUserShow(nameLable, HeDisplayUtil.urlDecode(data.nickname), 130, data.userShow)
            // }
        }
        // else {
        //     // console.log("battlepass refreshRankItemContent nousershow")
        //     //如果没有 用自己的labelid 感觉好像走不到这里
        //     let userShowRef = UserManager.getInstance().getUserShowRef()
        //     let labelid = userShowRef.getNameLabelId()
        //     // nameLable.originFontColor = nameLable.getTextColor();
        //     UIUtils.createNameWithUserShow(nameLable, HeDisplayUtil.urlDecode(data.nickname), 140, null, {label : labelid})
        // }

        var scoreLable = item.getChildByName("num1")
        scoreLable = removeAndNew(scoreLable)
        scoreLable.setString(data.totalScore);
        var rateLable = item.getChildByName("txt3")
        rateLable = removeAndNew(rateLable)
        if (data.winRate == "???"){
            rateLable.setString("胜率"+data.winRate);
        }else{
            rateLable.setString("胜率"+data.winRate+"%");
        }
        var photo = item.getChildByName("frame_photo").getChildByName("photo");
        var x = photo.x;
        var y = photo.y;
        photo.nodeExist = false;
        item.getChildByName("frame_photo").getChildByName("photo").removeFromParent(true);
        var photo2 = cc.Sprite.createWithSpriteFrameName("panel_pvp/photo.png");
        item.getChildByName("frame_photo").addChild(photo2);
        photo2.setName("photo");
        photo2.x = x;
        photo2.y = y;
        photo2.idx = idx;
        DressManager.getInstance().addHeadFrameByUseShow(photo2,data.userShow, 1.15)

        HeadImageLoader.loadImage(photo2, data.avatar);
    }else{
        item.setVisible(false);
    }
}

FriendPvpActivityMainPanel.prototype.requestCreateRoom = function () {
    var self = this;
    
    var userInfo = {"name": UserManager.getInstance().profile.name, "avatar": UserManager.getInstance().profile.headUrl};
    var onSuccess = function(){
        cc.log("----connect success, not create room success----");
    }
    var onFail = function(){
        self.isBusy = false;
        Toast.make(getText("pvp.link.error"));
    }
    self.logic.pvpManager.createRoom(userInfo, onSuccess, onFail);
}

FriendPvpActivityMainPanel.prototype.onCreateRoom = function () {
    cc.log("onCreateRoom");
    var self = this;
    self.isBusy = false;
    self.roomInited = true;
    self.logic.pvpManager.isInvitedPlayer = false;
    self.inviteFriend();
}

FriendPvpActivityMainPanel.prototype.handlePvpNotOpen = function(){
    cc.log("handlePvpNotOpen");
    var self = this;
    self.isBusy = false;
    self.roomInited = false;
}

FriendPvpActivityMainPanel.prototype.inviteFriend = function () {
    let self = this;
    if (self.isBusy) {
        return;
    }
    self.isBusy = true;

    // if (__DEBUG){
    //     self.isBusy = false;
    //     self.logic.showMatchPanel();
    //     return;
    // }

    if (!self.roomInited) {
        Toast.make("数据还没准备好哦，请稍后！", 1, () => {
            self.isBusy = false;
        })
        return;
    }
    let roomid = self.logic.pvpManager.getRoomId()
    function onSuccess() {
        self.isBusy = false;
        self.logic.showMatchPanel();
    }
    function onFail() {
        Toast.make(getText("pvp.sharefailed"));
        self.logic.pvpManager.isInvitedPlayer = false;
        self.logic.pvpManager.isRobot = false;
        self.logic.pvpManager.mode = 1;
        self.logic.closedByClient = true;
        self.logic.pvpManager.leaveRoom();

        let onCloseRoom = ()=> {
            self.logic.pvpManager.clearEvent();
            self.logic.pvpManager.initSocket();
            self.isBusy = false;
        }
        self.logic.closeRoom(onCloseRoom, onCloseRoom);
    }
    ShareUtil.clickPvpNew(roomid, onSuccess, onFail, onFail);
}

FriendPvpActivityMainPanel.prototype.onLeaveRoom = function(){
    var self = this;
    self.roomInited = false;
}

FriendPvpActivityMainPanel.prototype.onCleanup = function() {
    let self = this;
    if (self.letterNewFlag) {
        self.letterNewFlag.removeFromParent(true);
        self.letterNewFlag = null;
    }
    self.resourceRelease = true;
    
    ResManager.release(self.res)
    // ResManager.release(["packed/PvpRes.pack"]);
    
}

FriendPvpActivityMainPanel.prototype.rewardCanGetAnim = function(node) {
    var self = this;
    let shakeTime = 0.08
    let shakeAngle = 10
    self.canGetIcon.runAction(
        cc.RepeatForever.create(
            cc.Sequence.create(
                cc.RotateTo.create(shakeTime, shakeAngle),
                cc.RotateTo.create(shakeTime, 0-shakeAngle*0.75),
                cc.RotateTo.create(shakeTime, shakeAngle*0.5),
                cc.RotateTo.create(shakeTime, 0-shakeAngle*0.2),
                cc.RotateTo.create(shakeTime, shakeAngle*0.1),
                cc.RotateTo.create(shakeTime, 0),
                cc.DelayTime.create(1)
            )
        )
    )
}

FriendPvpActivityMainPanel.prototype.getRankRewards = function(evt) {
    var self = this;
    var w = self.progressTimer.width;
    var score = evt.target.name;
    if (score > self.activityInfo.totalScore){
        self.scoreBubble.getChildByName("txt").removeFromParent(true);
        var txt = getText("pvp.reward.unreceived").replace("{score}", score-self.activityInfo.totalScore);
        var label = cc.LabelTTF.create(txt, null, 23);
        self.scoreBubble.addChild(label);
        label.setName("txt");
        label.setAnchorPoint(cc.p(0.5, 0.5));
        label.setPosition(76, -32);
        label.setFontFillColor(cc.c3b(0, 153, 153));
        label.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        self.scoreBubble.x = w*score/self.scoreMax-45;
        self.scoreBubble.setVisible(true);
        if (score > self.scoreMax/2){
            self.scoreBubble.getChildByName("bubblebox").scaleX = -1;
            self.scoreBubble.getChildByName("bubblebox").x = 160;
            self.scoreBubble.x -= 20
        }else{
            self.scoreBubble.getChildByName("bubblebox").scaleX = 1;
            self.scoreBubble.getChildByName("bubblebox").x = -10;
        }
        return;
    }
    for(var i = 1; i < self.activityInfo.scoreRewardsIsGain.length; i++){
        cc.log(score, self.activityInfo.scoreRewardsIsGain[i])
        if (score == self.activityInfo.scoreRewardsIsGain[i]){
            self.scoreBubble.getChildByName("txt").removeFromParent(true);
            var txt = getText("pvp.reward.received");
            var label = cc.LabelTTF.create(txt, null, 23);
            self.scoreBubble.addChild(label);
            label.setName("txt");
            label.setAnchorPoint(cc.p(0.5, 0.5));
            label.setPosition(76, -32);
            label.setFontFillColor(cc.c3b(0, 153, 153));
            label.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

            self.scoreBubble.x = w*score/self.scoreMax-45;
            self.scoreBubble.setVisible(true);
            if (score > self.scoreMax/2){
                self.scoreBubble.getChildByName("bubblebox").scaleX = -1;
                self.scoreBubble.getChildByName("bubblebox").x = 160;
                self.scoreBubble.x -= 20
            }else{
                self.scoreBubble.getChildByName("bubblebox").scaleX = 1;
                self.scoreBubble.getChildByName("bubblebox").x = -10;
            }
            return;
        }
    }
    var onSuccess = function(evt){
        // 领取了积分奖励后刷新气泡去掉，刷新积分进度条
        self.scoreBubble.setVisible(false);
        if (self.canGetIcon){
            self.canGetIcon.stopAllActions();
            self.canGetIcon = null;
        }
        table.insert(self.activityInfo.scoreRewardsIsGain, score);
        self.refreshScoreProgress();
        var data = evt.data.rewards;
        var rewards = new Array();
        for(var i = 1; i < data.length; i++){
            rewards.push({itemId:data[i].itemId, num:data[i].num});
        }
        var addRewards = table();
        for(var i = 0; i < rewards.length; i++){
            table.insert(addRewards, rewards[i]);
        }
        // UserProp.getInstance().addPropList(addRewards);
        var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
        GetRewardsPanel.show(ContinueCheckName.kFriendPvp, rewards, true, null, true);
    }
    var onFail = function(evt){
        cc.error(evt);
    }
    var http = GainScoreRewardHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(score);
}

FriendPvpActivityMainPanel.prototype.standingPanelCloseCb = function(newTotalScore, newAdTicket){
    var self = this;
    self.isBusy = false;
    self.setLetterNew(false);
    if (newTotalScore){
        self.activityInfo.totalScore = newTotalScore;
    }
    if (newAdTicket){
        self.activityInfo.adTicketCount = newAdTicket;
    }
    
    // var scoreTxt = self.getChildByName("num");
    // scoreTxt.setString(self.activityInfo.totalScore); //总积分
    // self.selfScoreItem.getChildByName("num1").setString(self.activityInfo.totalScore);

    self.getRankList();
}

FriendPvpActivityMainPanel.prototype.getScoreTxtPosition = function(){
    var self = this;
    var scoreTxt = self.getChildByName("num");
    var scoreTextPosInWorld = self.convertToWorldSpace(scoreTxt.getPosition());
    return scoreTextPosInWorld;
}

// 领取积分后的积分动画
FriendPvpActivityMainPanel.prototype.showGetScoreTxtAnim = function(){
    var self = this;
    var scoreTxt = self.getChildByName("num");
    var refreshScore = function(){
        scoreTxt.setString(self.activityInfo.totalScore);
    }
    scoreTxt.runAction(cc.sequence(cc.scaleTo(0.15, 1.2), cc.callFunc(refreshScore), cc.scaleTo(0.15, 1)));

    self.refreshScoreProgress();
}

FriendPvpActivityMainPanel.prototype.getTicketIconPosition = function(){
    var self = this;
    var ticketNode = self.getChildByName("ticket2");
    var ticketNodePosInWorld = self.convertToWorldSpace(ticketNode.getPosition());
    return ticketNodePosInWorld;
}

// 领取积分后的积分动画
FriendPvpActivityMainPanel.prototype.showTicketNumAnim = function(){
    var self = this;
    var times = self.activityInfo.freeCount + self.activityInfo.adTicketCount;
    var ticketNode = self.getChildByName("ticket2");
    var refreshTicket = function(){
        ticketNode.getChildByName("num").setString("x"+times);
    }
    ticketNode.runAction(cc.sequence(cc.scaleTo(0.15, 1.2), cc.callFunc(refreshTicket), cc.scaleTo(0.15, 1)));
}

FriendPvpActivityMainPanel.prototype.resetBusy = function(){
    var self = this;
    self.isBusy = false;
}

// FriendPvpActivityMainPanel.prototype.popup = function (callback) {
//     var self = this
//     var targetScale = self.getScale()*1.1
//     self.setScale(0)
//     var time = 7 / 30
//     PopoutManager.getInstance().addWithBgFadeIn(self, true, false, callback)
//     var vSize = cc.Director.getInstance().getVisibleSize();
//     var dH = display.height-GamePlayConfig_Design_Height;
//     var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(40, 1120 + dH/2));
//     var pos_O = cc.p(vSize.width / 2, vSize.height / 2)
//     var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
//     self.setScale(0.23)
//     self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
//     self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
//     return self
// }

FriendPvpActivityMainPanel.prototype.setLetterNew = function(isShow) {
    let self = this
    if (!isShow) {
        if (self.letterNewFlag) {
            self.letterNewFlag.stopAllActions();
            self.letterNewFlag.setVisible(false);
        }
    } else {
        if (!self.letterNewFlag) {
            let letter2 = self.getChildByName("letter2");
            let lb = cc.Sprite.createWithSpriteFrameName("homeLib/lib_lb_new.png")
            lb.setVisible(false)
            self.letterNewFlag = lb;
            letter2.addChild(self.letterNewFlag)
        }
        if (!self.letterNewFlag.isVisible()) {
            let offsetx = 120
            let offsety = -30;
            self.letterNewFlag.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.MoveTo.create(0.2333, cc.p(17.25 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(17.25 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), cc.MoveTo.create(0.3, cc.p(8.5 + offsetx, offsety + 0)), cc.MoveTo.create(0.2333, cc.p(0 + offsetx, offsety + 0)))))
            self.letterNewFlag.setVisible(true);
        }
    }
}

FriendPvpActivityMainPanel.prototype.updateSubmsgPvp = function(subAccepted){
    var self = this
    if (subAccepted){
        cc.UserDefault.getInstance().setStringForKey("pvp_submsg", self.lastPvpTime)
    }
}

FriendPvpActivityMainPanel.prototype.trySubscribeMsg = function(){
    var self = this

    if (self.subMsg){
        let userInstance = cc.UserDefault.getInstance()
        let sendMsg = false
        var d = self.pvpRandomDuration.split(",");
        if (d && d[0]){
            let curDate = new Date()
            let year = curDate.getFullYear().toString()
            let month = (curDate.getMonth()+1).toString()
            let day = curDate.getDate().toString()
            let strTime = year+'-'+month+'-'+day+' '+d[0]
            strTime = year+'-'+month+'-'+day+' '+'16:00'
            let targetTime = new Date(strTime).getTime()
            let curTime = curDate.getTime()
            if (curTime > targetTime){
                console.log("@@@@pvp add one day")
                targetTime += 86400000
            }
            console.log("@@@@pvp targetTime:", strTime, " ",formatTime2Str2(targetTime))
            self.lastPvpTime = userInstance.getStringForKey("pvp_submsg")
            if (string.isEmpty(self.lastPvpTime) || curTime > self.lastPvpTime){
                console.log("@@@@really pvp need send msg")
                sendMsg = true
                self.lastPvpTime = targetTime
            }
        }
        self.subMsg.trySubscribeMsg(sendMsg, handler(self, self.updateSubmsgPvp))
    }
}

FriendPvpActivityMainPanel.prototype.initSubscribeMessage =function(){
    var self = this
    if (self.subMsg != null)
        return;
    
    var subKey = "";
    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
        subKey = "ccYFNfk1DhFY3rYcOsqxNQ_gWYfDcbQkYOBqK_6wcNQ";
    }else if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame) {
        subKey = "72cb3d610cc4f1d2e1154c71d607a004";
    }

    var moduleId = UISubscribeMsg.getModuleId(subKey)
    let subCfg = MetaManager.getInstance().getSubscribeCfg()
    console.log("@@@@get sub cfg:", subCfg, " moduleId:", moduleId)
    if (!subCfg[moduleId] || subCfg[moduleId] <= 0)
       return;

    console.log("@@@@run init sub,")
    if (window.mini && mini.supportSubscribeMessage()){
        UISubscribeMessage.preload().then(
            ()=>{
                self.subMsg = UISubscribeMsg.create(
                    subKey, 
                    getText("subscription_pvp_text"),
                    //cc.c3b(126,115,110),
                    cc.c3b(9,83,206),
                    false,
                    true,
                    false,
                    true,
                    getText("subscription_pvp_success"),
                    getText("subscription_pvp_fail"),
                    28
                    )
                let width = (self.getContentSize().width - self.subMsg.getWidth()) * 0.5;
                var time2 = self.getChildByName("txt_time2");
                let pos = time2.getPosition()
                self.subMsg.setPosition(width, pos.y - 100)
                self.addChild(self.subMsg)
                self.subMsg.on("submsg_select", ()=>{self.trySubscribeMsg()})
                self.subMsg.runAction(
                    cc.RepeatForever.create(
                        cc.Sequence.create(
                            cc.MoveTo.create(1.0, width, pos.y-95),
                            cc.MoveTo.create(1.0, width, pos.y-105)
                            )
                    )
                )
            }).catch(()=>{console.log("@@@@error")})
    }
}

module.exports = FriendPvpActivityMainPanel